var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "divider",
    style: {
      'borderLeftColor': _vm.bordercolor
    }
  }, [_c('span', {
    staticClass: "progressBg",
    style: _vm.dividerStyle
  }), _vm.progress === 1 ? _c('div', {
    staticClass: "awardicon",
    style: {
      'background-image': 'url(' + _vm.trophy + ')'
    }
  }) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }